module.exports = __webpack_public_path__ + "static/media/galeryBaseboards2.ae1001c8.jpg";